import Vue from 'vue'

export default Vue.component('message', {
    props: ['text', 'show'],
    template: '<div v-if="show" class="panel"><div class="panel-body text-center text-muted"><p>{{ text }}</p></div></div>'});